import { VALIDATION_RULES } from '../constants/movementConceptsConstants';

/**
 * Valida los datos de un concepto de movimiento.
 * @param {Object} movementConceptData
 * @returns {Object} Errores de validación
 */
export const validateMovementConcept = (movementConceptData) => {
  const errors = {};

  VALIDATION_RULES.REQUIRED_FIELDS.forEach((field) => {
    const value = movementConceptData[field];
    if (!value || value.toString().trim() === '') {
      errors[field] = 'El campo es obligatorio';
    }
  });

  if (movementConceptData.name) {
    const name = movementConceptData.name.trim();
    if (name.length > VALIDATION_RULES.MAX_LENGTHS.name) {
      errors.name = `El nombre no puede superar los ${VALIDATION_RULES.MAX_LENGTHS.name} caracteres`;
    }
  }

  if (movementConceptData.code) {
    const code = movementConceptData.code.trim();
    if (code.length > VALIDATION_RULES.MAX_LENGTHS.code) {
      errors.code = `El código no puede superar los ${VALIDATION_RULES.MAX_LENGTHS.code} caracteres`;
    }
  }

  if (movementConceptData.description) {
    const description = movementConceptData.description.trim();
    if (description.length > VALIDATION_RULES.MAX_LENGTHS.description) {
      errors.description = `La descripción no puede superar los ${VALIDATION_RULES.MAX_LENGTHS.description} caracteres`;
    }
  }

  return errors;
};

/**
 * Normaliza los datos antes de enviarlos al backend.
 * @param {Object} movementConceptData
 * @returns {Object}
 */
export const prepareMovementConceptData = (movementConceptData) => {
  const cleanedData = {
    ...movementConceptData,
  };

  if (cleanedData.name) {
    cleanedData.name = cleanedData.name.trim();
  }

  if (cleanedData.code) {
    cleanedData.code = cleanedData.code.trim().toUpperCase();
  }

  if (cleanedData.description) {
    cleanedData.description = cleanedData.description.trim();
  }

  Object.keys(cleanedData).forEach((key) => {
    if (cleanedData[key] === '' || cleanedData[key] === null) {
      delete cleanedData[key];
    }
  });

  return cleanedData;
};
